export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/city.b93f6bd.svg";